/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedureSimulationsTestRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations/test';

export default AutomationFinAIAgentProcedureSimulationsTestRoute;
